import type { ReactNode, JSX } from 'react';
import { styled } from 'styled-components';
import { isNil } from '@wistia/type-guards';

const ListItemComponent = styled.li`
  margin-bottom: var(--wui-space-02);
`;

export type ListItemProps = {
  /**
   * Pass an arbitrary child node
   */
  children?: ReactNode;
};

export const ListItem = ({ children }: ListItemProps): JSX.Element | null => {
  if (isNil(children)) {
    return null;
  }

  return <ListItemComponent>{children}</ListItemComponent>;
};

ListItem.displayName = 'ListItem';
